import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { approvedBadgeIcon } from '@ld.consumer-portal/data-uri';
import { SvgIconComponent } from '@ld.consumer-portal/ui-shared';
import { BrowserService } from '@ld.consumer-portal/utils';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-heloc-eligibility-popup',
  imports: [BaseModalComponent, SvgIconComponent, TranslocoDirective],
  templateUrl: './heloc-eligibility-popup.component.html',
  styleUrl: './heloc-eligibility-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelocEligibilityPopupComponent {
  protected readonly approvedBadgeIcon = approvedBadgeIcon;
  protected readonly helocSiteUrl = 'https://welcome.loandepot.com/?c=1cvmo326&ls=CP_CTA_HELOC2';

  private readonly browserService = inject(BrowserService);

  isVisible = input<boolean>(true);

  continue = output<void>();

  remindLater = output<void>();

  dismiss = output<void>();

  protected onContinue(): void {
    this.browserService.openUrl(this.helocSiteUrl);
    this.continue.emit();
  }

  protected onRemindLater(): void {
    this.remindLater.emit();
  }

  protected onDismiss(): void {
    this.dismiss.emit();
  }
}
